'use client'

// Next requires this file to be a Client Component; the boundary itself lives in
// one shared component so the 15 segments stay identical by construction.
export { SegmentError as default } from '@/components/molecules/segment-error'
